import { render } from "./Dashboard-EIS-Pejabat-Daerah.vue?vue&type=template&id=10448a74"
import script from "./Dashboard-EIS-Pejabat-Daerah.vue?vue&type=script&lang=js"
export * from "./Dashboard-EIS-Pejabat-Daerah.vue?vue&type=script&lang=js"

import "./Dashboard-EIS-Pejabat-Daerah.vue?vue&type=style&index=0&id=10448a74&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__